import { zodResolver } from "@hookform/resolvers/zod";

import { joinAddressLine } from "../components/raFormat";
import { ConstructionSiteMeta } from "./ConstructionSiteMeta";
import {
  AppEdit,
  AppFormContent,
  AppFormSection,
  AppSimpleForm,
  SectionHeader,
  AppTextInput,
  AppReferenceInput,
  AppFormToolbar,
} from "@/adapters/inbound/layout";
import { constructionSiteEditFormSchema } from "../schemas";
import { toUpdateConstructionSiteCommand } from "../mappers";

function ConstructionSiteEditFields() {
  return (
    <>
      <AppTextInput source="label" label="Bezeichnung" fullWidth />

      <AppReferenceInput
        source="clientId"
        reference="clients"
        label="Kunde"
        autocompleteProps={{
          optionText: "name",
          fullWidth: true,
        }}
      />

      <AppReferenceInput
        source="addressId"
        reference="addresses"
        label="Adresse"
        autocompleteProps={{
          optionText: (record: any) => joinAddressLine(record),
          fullWidth: true,
        }}
      />
    </>
  );
}

export const ConstructionSiteEdit = () => (
  <AppEdit
    aside={<ConstructionSiteMeta />}
    transform={toUpdateConstructionSiteCommand}
  >
    <AppSimpleForm
      resolver={zodResolver(constructionSiteEditFormSchema) as any}
      mode="onBlur"
      toolbar={<AppFormToolbar />}
    >
      <AppFormSection>
        <SectionHeader
          title="Stammdaten"
          subtitle="Grunddaten des Einsatzorts."
        />
        <AppFormContent>
          <ConstructionSiteEditFields />
        </AppFormContent>
      </AppFormSection>
    </AppSimpleForm>
  </AppEdit>
);
